import { render, staticRenderFns } from "./referrals.vue?vue&type=template&id=ec820a54&"
import script from "./referrals.vue?vue&type=script&lang=js&"
export * from "./referrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports